import React, { useState, useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getCurrentUserId, getMedsHistory, setMedsHistoryLoaded } from 'store/storeValtio';
import Spinner from 'components/spinner/Spinner';
import moment from 'moment';
import { deleteHistoryLocal } from 'store/localDb';

export default function Cleanup() {
  const navigate = useNavigate();
  const history = getMedsHistory();
  const currentUserId = getCurrentUserId();
  const [refresh, setRefresh] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [historyCount, setHistoryCount] = useState(null);

  const startDate = useRef(null);
  console.log('Cleanup', history.length, startDate, startDate.current);
  if (startDate.current === null) {
    console.log('useRef startDate', startDate.current);
    startDate.current = moment().startOf('day').subtract(1, 'month').toDate();
  }

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms || 1000));
  }
  
  function countHistory() {
    const dateISO = moment(startDate.current).toISOString();
    console.log('countHistory', startDate, dateISO);
    let count = 0;
    history.forEach((h, ix) => {
      //const medId = h.medicationId;
      const taken = h.date;
      if (taken < dateISO) ++count;
      //console.log( 'count', taken, dateISO, count);
    });
    console.log('HistoryCount', historyCount, count);
    if (count === historyCount) setRefresh(!refresh); //force refresh
    setHistoryCount(count);
  }

  useMemo(() => {
      countHistory();
  }, []);

  async function onSubmit() {
    console.log('submitting');
    setSubmitted(true);
    const sdISO = moment(startDate.current).toISOString();
    var count = 0;
    await Promise.all(history.map(async (h) => {
      const taken = h.date;
      //console.log(taken);
      if (taken < sdISO) {
        console.log('deleteHistory', h );
        await deleteHistoryLocal(currentUserId, h.id);
        ++count;
        }
      }));

    //setMedsHistoryLoaded(false);
    console.log( 'HistoryDeleted: ', count);
    setSubmitted(false);
    console.log('submitted');
    countHistory(); // this will cause a refresh
  }

  function setStartDate(d) {
    console.log('setStartDate', d);
    startDate.current = d;
    countHistory();
  }

  function handleClose() {
    navigate("/")
  }

  if (submitted) return (<Spinner/>);

  return (
    <div className='mt-8 text-center font-bold text-2xl '>
      {/* style={{textAlign: 'center', height: '400px', color: 'black', marginTop: '50px'}}> */}
      Delete medication history
      <div className='mt-4 text-xl font-semibold'>
        Delete history before:
      </div>
      <div className='mt-4'>
        <DatePicker selected={startDate.current} onSelect={(e)=>setStartDate(e)} />
      </div>
      <div className='m-8'>
        Items to delete: {historyCount}
      </div>
      <div className=''>
          <button 
            onClick={()=>onSubmit()} 
            disabled={submitted} 
            className='plainBtn small:ml-4 my-1 text-lg small:text-xl phone:text-2xl text-white bg-green-600'
            >
            Delete history items
          </button>
          <br />
          <button 
            onClick={handleClose} 
            className='plainBtn mr-4 my-1 text-lg small:text-xl phone:text-2xl text-white bg-red-600'
            >
              Cancel
            </button>
      </div>

    </div>
  );
}
